import Vue from 'vue'
import Store from '@/store'
import * as Cookie from 'tiny-cookie'
import Router from 'vue-router'
Vue.use(Router)

import { isSubdomain, isPortal } from './helpers.js'
import siteRoutes from './site.js'
import onboardingRoutes from './onboarding.js'
import authRoutes from './auth.js'
import bookingRoutes from './booking.js'
import customerRoutes from './customer.js'
import trackingRoutes from './tracking.js'
import dashboardRoutes from './dashboard.js'
import dispatchRoutes from './dispatch.js'
import monitorRoutes from './monitor.js'
import miscRoutes from './misc.js'

const portalRoutes = [
  {
    name: 'Portal',
    path: '',
    component: () => import(/* webpackChunkName: "portal" */ '@/layouts/Portal.vue'), 
    children: [
      ...bookingRoutes, 
      ...customerRoutes,
      ...trackingRoutes
    ]
  }
]

const defaultRoutes = [
  ...siteRoutes,
  ...onboardingRoutes,
  ...authRoutes,
  ...dashboardRoutes,
  ...dispatchRoutes,
  ...monitorRoutes,
  ...portalRoutes,
  ...miscRoutes
]

const router = new Router({
  routes: isSubdomain() || isPortal() ? portalRoutes : defaultRoutes,
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  linkExactActiveClass: 'active-exact',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      document.querySelector(to.hash).scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
    } else {
      return { 
        x: 0, 
        y: 0 
      }
    }
  }
})

router.beforeEach(async (to, from, next) => {
  /**
   * Sync account if it's not there before navigating
   */
  if (Cookie.get('token') && !Store.state.user) {
    await Store.dispatch('syncUser')
  }

  if (Cookie.get('customer_token') && !Store.state.user) {
    await Store.dispatch('customer/syncCustomer')
  }

  let user = Store.state.user || null
  let customer = Store.state.customer.customer || null

  if (to.matched.some(route => route.meta.authUser) && !user) {
    next({ name: 'Login', query: { redirect: to.fullPath } })
  } else if (to.matched.some(route => route.meta.authCustomer) && !customer) {
    next({ name: 'CustomerLogin', query: { redirect: to.fullPath } })
  } else {
    next()
  }
})

export default router